import Routes from '@tabeeb/routes'
import { NavbarItem } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import { CertificatesIcon } from '@tabeeb/shared/icons'
import { getShowCertificatesManagement } from '@tabeeb/modules/certificates/selectors'
import { getShowQualificationManagement } from '@tabeeb/modules/qualifications/selectors'

const CertificatesTab: React.FC = () => {
  const showCertificates = useSelector(getShowCertificatesManagement)
  const showQualifications = useSelector(getShowQualificationManagement)
  if (!showCertificates && !showQualifications) {
    return null
  }

  return (
    <NavbarItem
      name='Certificates'
      href={showCertificates ? Routes.certificates : Routes.qualifications}
      icon={<CertificatesIcon />}
    >
      {showCertificates && <NavbarItem subitem href={Routes.certificates} name='Certificates' />}
      {showCertificates && <NavbarItem subitem href={Routes.certificateTypes} name='Certificate types' />}
      {showQualifications && <NavbarItem subitem href={Routes.qualifications} name='Qualifications' />}
      {showQualifications && <NavbarItem subitem href={Routes.qualificationUsers} name='Users qualifications' />}
    </NavbarItem>
  )
}

export default CertificatesTab

